export class attachmentMaster{
    CLIENT_ID: number;
    ID: number;
    TYPE: number;
    TYPE_ID: number;
    ATTACHMENT_URL: string;
    USER_ID: number;
    UPDATED_DATETIME: any;
    IS_ACTIVE: boolean;
}